import http from '~src/core/api/client'

export default {
  getThings: (params) => http.get('example/things', { params })
}
